(function(){
if(window.__cclInit)return;window.__cclInit=1;
function $(s,r){return (r||document).querySelectorAll(s)}
function run(){
$('[data-ccl-filter]').forEach(function(root){
  var chips=$('.ccl-chip',root),cards=$('.ccl-card',root);
  chips.forEach(function(c){c.addEventListener('click',function(){
    var m=c.getAttribute('data-mood');
    chips.forEach(function(x){x.setAttribute('aria-pressed',x===c?'true':'false')});root.classList.add('ccl-flav--open');var mb=root.querySelector('[data-ccl-more]');if(mb)mb.hidden=true;
    cards.forEach(function(k){var ms=(k.getAttribute('data-moods')||'').split(' ');k.hidden=!(m==='all'||ms.indexOf(m)>-1)});
  })});
});
$('[data-ccl-more]').forEach(function(btn){
  var sec=btn.closest('[data-ccl-filter]');
  btn.addEventListener('click',function(){
    if(!sec)return;
    sec.classList.add('ccl-flav--open');btn.setAttribute('aria-expanded','true');btn.hidden=true;
  });
});
$('[data-ccl-age]').forEach(function(box){
  var key='ccl-age-ok',days=+box.getAttribute('data-days')||30,now=Date.now();
  var ok=0;try{ok=+(localStorage.getItem(key)||0)}catch(e){}
  if(ok&&now-ok<days*864e5)return;                 // уже отвечал, не мешаем
  box.hidden=false;document.documentElement.style.overflow='hidden';
  var close=function(){box.hidden=true;document.documentElement.style.overflow=''};
  var yes=box.querySelector('[data-ccl-age-yes]'),no=box.querySelector('[data-ccl-age-no]');
  if(yes)yes.addEventListener('click',function(){try{localStorage.setItem(key,String(now))}catch(e){}close()});
  if(no)no.addEventListener('click',function(){window.location.href='/'});
  if(yes)yes.focus();
});
$('[data-ccl-fund]').forEach(function(root){
  var goal=+root.getAttribute('data-goal'),per=+root.getAttribute('data-per'),sold=+root.getAttribute('data-sold')||0,total=Math.round(goal/per),n=3;
  var quips;try{quips=JSON.parse(root.querySelector('[data-quips]').textContent)}catch(e){quips=[]}
  var f=function(v){return Number(v).toLocaleString('en-US')};
  function draw(){
    var left=Math.max(0,total-sold-n);
    root.querySelector('[data-left]').textContent=f(left);
    root.querySelector('[data-n]').textContent=n;
    root.querySelector('[data-mine]').textContent='€'+f(n*per);
    root.querySelector('[data-pct]').textContent=(n*per/goal*100).toFixed(3)+'%';
    var done=sold/total*100,you=Math.min(n,total-sold)/total*100;
    root.querySelector('.ccl-bar__done').style.width=done.toFixed(2)+'%';
    var y=root.querySelector('.ccl-bar__you');y.style.left=done.toFixed(2)+'%';y.style.width=you.toFixed(2)+'%';
    var q='';quips.forEach(function(x){if(n>=x[0])q=x[1]});root.querySelector('[data-quip]').textContent=q;
  }
  root.querySelector('[data-dec]').addEventListener('click',function(){n=Math.max(1,n-1);draw()});
  root.querySelector('[data-inc]').addEventListener('click',function(){n=Math.min(99,n+1);draw()});
  draw();
});
$('[data-ccl-pdp]').forEach(function(root){
  var main=root.querySelector('.ccl-gal__main img');
  $('.ccl-gal__thumbs button',root).forEach(function(b){b.addEventListener('click',function(){
    if(main){main.src=b.getAttribute('data-src');main.srcset='';main.alt=b.getAttribute('aria-label')||'';}
    $('.ccl-gal__thumbs button',root).forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
  })});
  var q=root.querySelector('.ccl-qty input');
  if(q){root.querySelector('[data-qd]').addEventListener('click',function(){q.value=Math.max(1,(+q.value||1)-1)});root.querySelector('[data-qi]').addEventListener('click',function(){q.value=(+q.value||1)+1})}
  var tabs=$('.ccl-tabs__list button',root);
  tabs.forEach(function(t){t.addEventListener('click',function(){tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on})})});
  var sticky=root.querySelector('.ccl-sticky'),buy=root.querySelector('.ccl-buy');
  if(sticky&&buy&&'IntersectionObserver' in window){new IntersectionObserver(function(e){sticky.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(buy)}
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
